import { render } from "./payitem.vue?vue&type=template&id=5af0cf53"
import script from "./payitem.vue?vue&type=script&lang=js"
export * from "./payitem.vue?vue&type=script&lang=js"

import "./payitem.vue?vue&type=style&index=0&id=5af0cf53&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__